"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var data_1 = require("./");
/**
 * Class to encapsulate a 1 Dimensional data segment that has an associated color with it.
 *
 * @export
 * @extends Chell1DSection
 */


var TintedChell1DSection =
/** @class */
function (_super) {
  __extends(TintedChell1DSection, _super);

  function TintedChell1DSection(label, start, end, color) {
    if (end === void 0) {
      end = start;
    }

    if (color === void 0) {
      color = 'orange';
    }

    var _this = _super.call(this, label, start, end) || this;

    _this.label = label;
    _this.sectionColor = 'orange';
    _this.sectionColor = color;
    return _this;
  }

  Object.defineProperty(TintedChell1DSection.prototype, "color", {
    get: function get() {
      return this.sectionColor;
    },
    enumerable: true,
    configurable: true
  });

  TintedChell1DSection.prototype.updateColor = function (color) {
    this.sectionColor = color;
  };

  return TintedChell1DSection;
}(data_1.Chell1DSection);

exports.TintedChell1DSection = TintedChell1DSection;